import { inject, Injectable } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AppwriteService } from '@shared/services/appwrite.service';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  private readonly _appwriteService = inject(AppwriteService);
  private readonly _sanitizer = inject(DomSanitizer);

  getSafeImageUrl(imageId: string, width: number, height: number): SafeUrl {
    const unsafeUrl = this._appwriteService.getImageUrl(imageId, width, height);
    return this._sanitizer.bypassSecurityTrustUrl(unsafeUrl);
  }
}
